export function keepDigits(value: string): string {
    const RE_DISALLOWED_CHARACTERS = /\D+/g;

    return value.replace(RE_DISALLOWED_CHARACTERS, '');
}
